import { DataBean } from "../DataBean";

export class MainTheme extends DataBean {


    public async getMainThemeCatalog(): Promise<any> {
        return this.getCustomService("PeopleArt", "java.util.List_getMainThemeCatalog_Number", [null]);
    }
}